// extracted by mini-css-extract-plugin
module.exports = {"vectorCropping":"style_vectorCropping__2RTy_"};